import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const listItem = style({
  listStyleType: 'disc',
  padding: themeVars.spacing.xs,
});

const list = style({
  paddingLeft: themeVars.spacing.xl,
  marginTop: themeVars.spacing.lg,
});

export const css = { listItem, list };
